var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1dc071",
    width: "64px",
    height: "64px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "6. Diamond",
    id: "_6._Diamond"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.89,14.55l-4-8A1,1,0,0,0,27,6H5a1,1,0,0,0-.89.55l-4,8,0,0a.32.32,0,0,1,0,.09,2.38,2.38,0,0,0,0,.26S0,15,0,15a.43.43,0,0,0,0,.05,1.27,1.27,0,0,0,.06.28s0,.05,0,.08a.8.8,0,0,0,.18.27l15,16a1,1,0,0,0,1.46,0l15-16A1,1,0,0,0,31.89,14.55ZM16,8.89,19.2,14H12.8Zm-5.08,4.34L7,8h7.2ZM17.8,8H25l-3.92,5.23Zm1.84,8L16,27.65,12.36,16ZM13.75,27.14,3.31,16h7Zm8-11.14h7L18.25,27.14Zm7.65-2H23l3.83-5.11ZM5.17,8.89,9,14H2.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,4a1,1,0,0,0,1-1V1a1,1,0,0,0-2,0V3A1,1,0,0,0,16,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.29,3.71a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42l-1-1A1,1,0,0,0,9.29,2.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,4a1,1,0,0,0,.71-.29l1-1a1,1,0,1,0-1.42-1.42l-1,1a1,1,0,0,0,0,1.42A1,1,0,0,0,21,4Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGem);
export default __webpack_public_path__ + "static/media/gem.935dbccbc8deb21a4edfd96840424a69.svg";
export { ForwardRef as ReactComponent };